module.exports = __webpack_public_path__ + "media/images/emblems/NatersWappen-8eb57858017c671a697ae7bafc08c6e6.png";